export default "__VITE_ASSET__BJbPLxM$__"